import jQuery from 'jquery';
import Flickity from 'flickity';

// Register our jquery version with Flickity.
Flickity.setJQuery(jQuery);

export default Flickity;
